var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "btn",
      class: _vm.buttonClass,
      attrs: {
        href: _vm.href,
        "aria-label": _vm.label,
        disabled: _vm.isDisabled
      }
    },
    [_c("span", [_vm._v(_vm._s(_vm.label))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }